import { useEffect, useState } from 'react';
import api from '../lib/api';

export default function PricingPage() {
  const [plans, setPlans] = useState(null);

  useEffect(() => {
    async function load() {
      try {
        const res = await api.get('/credits/plans');
        setPlans(res.data);
      } catch {}
    }
    load();
  }, []);

  return (
    <div className="fade-up">
      <div className="page-header" style={{ textAlign: 'center', maxWidth: 600, margin: '0 auto 32px' }}>
        <h1 className="page-title" style={{ fontSize: 32 }}>Pricing like SEMrush,<br/>built for Hostinger</h1>
        <p className="page-sub" style={{ fontSize: 14, marginTop: 8 }}>All 10 SEMrush tools included in every plan. No limits on domains or keywords — only credits.</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 16, maxWidth: 1100, margin: '0 auto 32px' }}>
        {(plans?.data || [
          { id: 'free', name: 'Free Trial', price: 0, credits: 15, period: '3 days', features: ['15 credits', 'All 10 tools', '3-day trial'] },
          { id: 'starter', name: 'Starter', price: 23, credits: 500, period: 'month', features: ['500 credits/month', 'All tools', 'API access', 'Email support'] },
          { id: 'pro', name: 'Pro', price: 59, credits: 2000, period: 'month', popular: true, features: ['2,000 credits/month', 'All Starter', 'Bulk analysis', 'Priority support', 'Historical data'] },
          { id: 'agency', name: 'Agency', price: 129, credits: 6000, period: 'month', features: ['6,000 credits/month', 'All Pro', '5 team members', 'White-label', 'Dedicated manager'] },
        ]).map(plan => (
          <div key={plan.id} className="card" style={{ margin: 0, borderColor: plan.popular ? '#111' : '#E5E7EB', borderWidth: plan.popular ? 2 : 1, position: 'relative' }}>
            {plan.popular && <div style={{ position: 'absolute', top: -10, left: '50%', transform: 'translateX(-50%)', background: '#111', color: 'white', fontSize: 10, fontWeight: 800, padding: '3px 12px', borderRadius: 99, letterSpacing: '0.05em' }}>MOST POPULAR</div>}
            <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 8 }}>{plan.name}</div>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginBottom: 4 }}><span style={{ fontWeight: 800, fontSize: 32 }}>${plan.price}</span><span style={{ fontSize: 12, color: '#6B7280' }}>/{plan.period}</span></div>
            <div style={{ fontSize: 12, color: '#6B7280', marginBottom: 16, paddingBottom: 16, borderBottom: '1px solid #F3F4F6' }}>{plan.credits.toLocaleString()} credits</div>
            <div style={{ marginBottom: 20 }}>
              {plan.features.map((f,i) => <div key={i} style={{ fontSize: 12, padding: '6px 0', display: 'flex', gap: 8, borderBottom: '1px solid #FAFBFC' }}><span style={{ color: '#00C853', fontWeight: 800 }}>✓</span>{f}</div>)}
            </div>
            <button className={`btn ${plan.popular ? 'btn-orange' : 'btn-white'}`} style={{ width: '100%' }}>{plan.price === 0 ? 'Start Free Trial' : 'Choose Plan'}</button>
          </div>
        ))}
      </div>

      <div className="card" style={{ maxWidth: 1100, margin: '0 auto 24px' }}>
        <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 12 }}>Credit Costs — like SEMrush</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12 }}>
          {[
            { action: 'Domain Overview', credits: 3 },
            { action: 'Organic Research', credits: 4 },
            { action: 'Keyword Overview', credits: 3 },
            { action: 'Keyword Magic Tool', credits: 5 },
            { action: 'Keyword Gap', credits: 5 },
            { action: 'Backlink Analytics', credits: 4 },
            { action: 'Backlink Gap', credits: 5 },
            { action: 'Site Audit', credits: 5 },
            { action: 'On Page Checker', credits: 3 },
          ].map(c => (
            <div key={c.action} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 12px', background: '#FAFBFC', borderRadius: 6, fontSize: 12 }}>
              <span>{c.action}</span><span className="badge badge-gray">{c.credits} cr</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ maxWidth: 1100, margin: '0 auto', background: '#111', color: 'white', borderRadius: 12, padding: 24, display: 'grid', gridTemplateColumns: '1fr auto', gap: 24, alignItems: 'center' }}>
        <div>
          <div style={{ fontWeight: 800, fontSize: 18, marginBottom: 6 }}>Hosting on Hostinger? One-click deploy ready 🚀</div>
          <div style={{ fontSize: 13, color: '#9CA3AF' }}>Frontend builds to static files for public_html. Backend runs as Node.js app in hPanel. Includes .htaccess for SPA routing.</div>
        </div>
        <div style={{ background: '#1F1F1F', borderRadius: 6, padding: '12px 16px', fontFamily: 'monospace', fontSize: 11, color: '#A0A0A0' }}>
          npm run build → upload build/ to public_html<br/>Node.js app → set startup file to server.js
        </div>
      </div>
    </div>
  );
}
